import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../../modules/notifier/services/actions';
import {UseStatisticParams} from '../useStatistic';
import {FeedbackDto} from '../../../dto/FeedbackDto';

export const getStatisticSubmittedFeedbacks = createAsyncThunk<FeedbackDto[], UseStatisticParams>(
    'consolidatedFeedback/getStatisticSubmittedFeedbacks',
    async ({projectId, recipientId, periodIds}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `feedback/${projectId}/${recipientId}`,
            method: ApiMethods.POST,
            body: periodIds
        });
        if (httpStatus === 200) {
            return responseData;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const getStatisticConsolidatedFeedbacks = createAsyncThunk<FeedbackDto[], UseStatisticParams>(
    'consolidatedFeedback/getStatisticConsolidatedFeedbacks',
    async ({projectId, recipientId, periodIds}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `feedback/consolidated/${recipientId}/${projectId}`,
            method: ApiMethods.POST,
            body: periodIds
        });
        if (httpStatus === 200) {
            return responseData;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
